import { Injectable } from '@angular/core';
import {
	ActivatedRouteSnapshot,
	Router,
	RouterStateSnapshot,
	UrlTree
} from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Authority } from 'src/app/shared/models/security/authority';
import { DateUtils } from 'src/app/shared/utils/date-utils';
import { FacadeService } from '../services/facade.service';

@Injectable({
	providedIn: 'root'
})
export class IsMissionRequestDetailAllowedGuard {
	constructor(
		private facade: FacadeService,
		private router: Router,
		private dateUtils: DateUtils
	) {}

	/**
	 * Autorise l'accès si l'utilisateur n'est pas project manager ou si la mission selectionnée correspond à une mission de celui-ci
	 * @param route
	 * @param state
	 * @returns
	 */
	canActivate(
		route: ActivatedRouteSnapshot,
		_state: RouterStateSnapshot
	):
		| Observable<boolean | UrlTree>
		| Promise<boolean | UrlTree>
		| boolean
		| UrlTree {
		if (
			this.facade.dataStorageService.isProjectManager() ||
			this.facade.dataStorageService.isProfessionnelSAE()
		) {
			let missionId = parseInt(route.paramMap.get('id'));

			let today = new Date();
			let weekNumber: number;
			let yearNumber: number;
			if (this.facade.dataStorageService.getParam('storedCalendarWeeknumber')) {
				weekNumber = this.facade.dataStorageService.getParam(
					'storedCalendarWeeknumber'
				) as number;
			}
			if (this.facade.dataStorageService.getParam('storedCalendarYearnumber')) {
				yearNumber = this.facade.dataStorageService.getParam(
					'storedCalendarYearnumber'
				) as number;
			} else {
				yearNumber = new Date().getFullYear();
			}
			today.setHours(0, 0, 0, 0);
			let searchedDate: Date;
			let secondSearchedDate: Date;
			if (weekNumber && weekNumber >= 1 && weekNumber <= 53) {
				searchedDate = this.dateUtils.getDateOfISOWeek(weekNumber, yearNumber);
			} else {
				searchedDate = this.dateUtils.getMonday(today);
				// weekNumber = this.dateUtils.getWeekNumber(today);
			}

			if (this.facade.dataStorageService.getParam('missionStartDate')) {
				searchedDate = new Date(
					this.facade.dataStorageService.getParam('missionStartDate')
				);
			}

			secondSearchedDate = new Date(searchedDate);
			secondSearchedDate.setDate(searchedDate.getDate() + 6);

			if (this.facade.dataStorageService.getParam('missionEndDate')) {
				secondSearchedDate = new Date(
					this.facade.dataStorageService.getParam('missionEndDate')
				);
			}

			return this.facade.missionService
				.getAllMissionsOfProjectManagerByDateformationBetween(
					searchedDate,
					secondSearchedDate,
					this.facade.dataStorageService.getUser()?.employee.id,
					this.facade.dataStorageService.getUser()?.employee.serviceCenter.id
				)
				.pipe(
					map((missions) => {
						let projectManagerMissionRequestsIds = missions.map(
							(mission) => mission.missionRequest.id
						);
						if (projectManagerMissionRequestsIds.includes(missionId)) {
							return true;
						} else {
							this.router.navigate(['/gestion/formations']);
							return false;
						}
					})
				);
		} else {
			return [
				Authority.DIRECTEUR_STRUCTURE,
				Authority.RESPONSABLE_CENTRE,
				Authority.PLANIFICATEUR
			].some(
				(authority) =>
					authority === this.facade.dataStorageService.getUser()?.role.id
			);
		}
	}
}
